import config from 'constants/config'
import { AppStore } from './store'
import * as Analytics from 'analytics/analytics'
import { isCountryEnabled } from 'components/Common/StickyPromptCard/useAbandonedCartSelectionLogic'
import { isLoggedIn } from 'selectors/accountSelectors'
import { isMobileSel } from 'selectors/configSelectors'

function initialiseAppsFlyer() {
  if (!config.MOBILE_APP_CUSTOMISATIONS) return

  import(/* webpackChunkName: "AppsflyerCapacitorPlugin" */ 'appsflyer-capacitor-plugin')
    .then(appsFlyerModule => {
      const { AppsFlyer } = appsFlyerModule

      const afConfig = {
        appID: config.MOBILE_APP_AF_APP_ID,
        devKey: config.MOBILE_APP_AF_DEV_KEY,
        isDebug: config.MOBILE_APP_AF_DEBUG,
        waitForATTUserAuthorization: 10, // for iOS 14 and higher
        registerOnDeepLink: true,
        registerConversionListener: true,
        registerOnAppOpenAttribution: false,
        useReceiptValidationSandbox: true, // iOS only
        useUninstallSandbox: true, // iOS only
      }

      AppsFlyer.initSDK(afConfig)
        .catch(e => {
          console.error('Error in AppFlyer Initialization', e)
        })
    },
    )
    .catch(e => {
      console.error('Error importing AppsFlyer module', e)
    })
}

function initialiseOptimizelyUser(store: AppStore) {
  if (!config.OPTIMIZELY_SDK_KEY) return

  const state = store.getState()

  const userId = state.config.optimizelyAnonymousUserId
  const inStoreMode = state.config.storeMode
  const isSpoofed = state.auth.account.isSpoofed
  const regionCode = state.geo.currentRegionCode
  const utmSource = state.utm.source || ''
  const utmMedium = state.utm.medium || ''
  const utmCampaign = state.utm.campaign || ''
  const optimizelyEnabled = userId && !inStoreMode && !isSpoofed
  const isUserWithPurchases = !!state.auth.account.total_purchase_count

  if (!optimizelyEnabled) return

  const attributes = {
    userId,
    regionCode,
    utmSource,
    utmMedium,
    utmCampaign,
    isLereStickyAcAudience: isCountryEnabled(regionCode),
    deviceName: isMobileSel(state) ? 'mobile' : 'desktop',
    isLoggedIn: isLoggedIn(state),
    isUserWithPurchases,
  }
  Analytics.init(Analytics.Tracker.optimizely, userId, attributes, store)
}

function initialiseSnowplow() {
  if (!config.TRACKING_HOST) return

  Analytics.init(Analytics.Tracker.snowplow)
}

export default function initialiseAnalytics(store: AppStore) {
  initialiseOptimizelyUser(store)
  initialiseSnowplow()
  initialiseAppsFlyer()
}
